import  { useMemo } from 'react'
import { useParams } from "react-router-dom";
import { Block } from 'baseui/block';
import { NavigationButton } from '../../components/NavigationButton/NavigationButton'
import {
  LabelLarge,
  ParagraphMedium,
} from 'baseui/typography';
import { IoQrCodeOutline } from 'react-icons/io5';
import { useNotAckedAlarms } from '../../hooks/useNotAckedAlarms';
import { AlarmDetailsDto } from '../../services/alarm';
import { AlarmListItem } from '../../features/Alarm/AlarmListItem';
import {  FormattedMessage } from 'react-intl';
import { useStyletron } from 'baseui';
import { useGetObjectByIdQuery } from '../../services/objects';
import { IAutomationObject } from '../../automationObjects';
import { HasSideviewPanel, SideviewPanelSelector } from '../../automationObjects/automationObjectsSelector';

export function SideView(props: any) {
  const { objectId, resourceGroupId } = useParams();
  const { data: app } = useGetObjectByIdQuery({ resourceGroupId: resourceGroupId || '', id: objectId || '' }, { skip: !objectId || !resourceGroupId, refetchOnReconnect: true })
  const [css, theme] = useStyletron();


  return (
    <Block width='100%' display='flex' flexDirection='column' gridRowGap={theme.sizing.scale800} >
      <Block marginTop={'20px'} marginBottom={'20px'} alignSelf={'end'} alignItems={'end'} alignContent={'end'} flexDirection='row'  >
        <NavigationButton href='/QRCode' title='QRCode-Scanner' >
          <IoQrCodeOutline size='2em'></IoQrCodeOutline>
        </NavigationButton>
      </Block>

      {app && objectId && <AppSpecificSideView {...app}></AppSpecificSideView>}
      {!objectId && <OverallAlarms></OverallAlarms>}

    </Block>
  )
}


const AppSpecificSideView = (props: IAutomationObject) => {
  const hasSideViewPanel = HasSideviewPanel(props.schema);
  return (
    <>
      {hasSideViewPanel &&
        <SideviewPanelSelector state={props} modelId={props.schema}></SideviewPanelSelector>
      }
      {!hasSideViewPanel &&
      <OverallAlarms></OverallAlarms>}
    </>
  )
}

const OverallAlarms = () => {
  
  const [css, theme] = useStyletron();
  const { count: notAckedAlarmsCnt, items: notAckedAlarms, isLoading } = useNotAckedAlarms()

  const notAckedAlarmsWithoutOff = useMemo(() => {
    return notAckedAlarms?.filter((v: AlarmDetailsDto) => !v.offTime);
  }, [notAckedAlarms])

  return (<>
    <LabelLarge><FormattedMessage id="sideView.importantAlarms" defaultMessage="Important Alarms" /></LabelLarge>
    <Block width='100%' display='flex' flexDirection='column' gridRowGap={theme.sizing.scale200} >
      {(notAckedAlarmsWithoutOff?.length === 0 && !isLoading) &&
        <ParagraphMedium><FormattedMessage id="sideView.noImportantAlarms" defaultMessage="There are no new important alarms right now" /> &#128578;</ParagraphMedium>
      }
      {notAckedAlarmsWithoutOff?.map((item: AlarmDetailsDto) =>
        <AlarmListItem count={0} alarms={[item]} key={item.id} small />
      )}
    </Block>
  </>)
}

